import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { hideDialog } from '~/actions/ui'
import { getDialogProps } from '~/selectors/ui'
import { translate } from '~/core/translate'
import Button from '../common/button'
import Modal from '../common/modal'
import { setActiveSession } from '~/actions/active-session'

const ConfirmJoinDialog = () => {
  const dispatch = useDispatch()
  const { details } = useSelector(getDialogProps)

  const handleClick = () => {
    dispatch(setActiveSession(details))
  }

  return (
    <Modal
      footerChildren={(
        <>
          <Button onClick={handleClick}>
            {translate('start')}
          </Button>
          <Button onClick={hideDialog} secondary>
            {translate('cancel')}
          </Button>
        </>
      )}
      title={translate('ready_to_start_meeting')}
    />
  )
}

export default ConfirmJoinDialog
